import { TransactionTag } from '../TransactionTag';

type Updatable = Pick<TransactionTag, 'label'>

const updateTransactionTag = (updatableProperties: Updatable, tag: TransactionTag) => {
	return Object.assign({}, tag, updatableProperties);
}

export default updateTransactionTag;